import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M21 14.5A9 6.5 0 0 1 5.5 19', key: '1xj2o6' }],
  ['path', { d: 'M3 9.5A9 6.5 0 0 1 18.5 5', key: '1gln3t' }],
  ['circle', { cx: '17.5', cy: '14.5', r: '3.5', key: '1ccu1t' }],
  ['circle', { cx: '6.5', cy: '9.5', r: '3.5', key: 'x5tc2d' }],
];

/**
 * @component @name ZodiacCancer
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTQuNUE5IDYuNSAwIDAgMSA1LjUgMTkiIC8+CiAgPHBhdGggZD0iTTMgOS41QTkgNi41IDAgMCAxIDE4LjUgNSIgLz4KICA8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTQuNSIgcj0iMy41IiAvPgogIDxjaXJjbGUgY3g9IjYuNSIgY3k9IjkuNSIgcj0iMy41IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/zodiac-cancer
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZodiacCancer = createLucideIcon('zodiac-cancer', __iconNode);

export default ZodiacCancer;
